import { configurationServiceInstance } from "services/ConfigurationService";

export const getRelationsKeysFromConfig = (taxonomyClass: string): string[] => {
  const schema = configurationServiceInstance.getTaxonomyItemByName(taxonomyClass);

  if (!schema) return [];

  return schema.meta.relations ? Object.keys(schema.meta.relations) : [];
}
